import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as API from "../../libs/service";

import ProductBox from '../../components/ProductBox';
import { setOrganization } from '../../redux/licenseSlice';
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { refreshLicenseData } from "../../libs/utils";
import { useNavigate } from 'react-router-dom';
import routes from '../../libs/routes';
import EduBox from '../../components/EduBox';

export default function Licensing() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);
    const pro = useSelector((s) => s.licenseReducer.pro);
    const art = useSelector((s) => s.licenseReducer.art);
    const all = useSelector((s) => s.licenseReducer.all);
    const edu = useSelector((s) => s.licenseReducer.edu);

    const organization = useSelector((s) => s.licenseReducer.organization);
    const lang = useSelector(state => state.langReducer.lang);
    const [payList, setpayList] = useState([]);
    const [subscribelist, setsubscribelist] = useState([]);

    useEffect(() => {
        if (!mbData?.idx) {
            navigate(routes.main);
        } else {
            fetchLicenseList();
            payinfolists();
        }
    }, [mbData]);
    const payinfolists = async() => {
        const result = await API.xsollaApis("user/subscribepaylist", {idx: mbData?.idx});
        //setMainCard();
        result?.result?.paylist?.map((x, i) => {
            x.plan = result?.result?.lists?.find(item => item?.id*1 === x?.subscriptionId).plan;
        });
        setpayList(result?.result?.paylist);
        setsubscribelist(result?.result?.lists);
        //console.log(result?.result);
    }

    const fetchLicenseList = async () => {
        dispatch(loadingStart());

        await refreshLicenseData(dispatch, mbData.idx);

        dispatch(loadingEnd());
    };

    const noLicense =
        (!pro || pro.length === 0) &&
        (!art || art.length === 0) &&
        (!all || all.length === 0) &&
        (!edu || edu.length === 0);

    function getEffectiveAttachedAt(license) {
        if (license.attachedAt && license.licenseGroup && license.licenseGroup.licenseCategory !== 4) {
            return new Date(license.attachedAt);
        }
        return new Date(license.createdAt);
    }

    function getEffectiveExpiration(license) {
        if (license.revokedAt) {
            return new Date(license.revokedAt);
        }
        if (license.licenseGroup && license.licenseGroup.expiredAt) {
            return new Date(license.licenseGroup.expiredAt);
        }
        return new Date(0);
    }

    function compareLicenses(a, b) {
        if (a.licenseGroup && b.licenseGroup) {
            const aExpired = getEffectiveExpiration(a);
            const bExpired = getEffectiveExpiration(b);

            const isAExpired = aExpired.getTime() < new Date().getTime();
            const isBExpired = bExpired.getTime() < new Date().getTime();

            if (isAExpired) {
                if (isBExpired) {
                    return getEffectiveAttachedAt(a) - getEffectiveAttachedAt(b);
                }
                return 1;
            }
            if (isBExpired) {
                return -1;
            }
        }
        if (a.revokedAt) {
            if (b.revokedAt) {
                return getEffectiveAttachedAt(a) - getEffectiveAttachedAt(b);
            }
            return 1;
        }
        if (b.revokedAt) {
            return -1;
        }
        
        const aAttach = getEffectiveAttachedAt(a);
        const bAttach = getEffectiveAttachedAt(b);
        if (aAttach.getTime() !== bAttach.getTime()) {
            return aAttach - bAttach;
        }
        const aCreated = new Date(a.createdAt);
        const bCreated = new Date(b.createdAt);
        if (aCreated.getTime() !== bCreated.getTime()) {
            return aCreated - bCreated;
        }
        return getEffectiveExpiration(a) - getEffectiveExpiration(b);
    }

    const sortedPro = [...pro].sort(compareLicenses);
    const sortedArt = [...art].sort(compareLicenses);
    const sortedAll = [...all].sort(compareLicenses);
    function getGroupRepresentative(group) {
        return Array.isArray(group) ? group[0] : group;
    }

    function isNotEmpty(data) {
        if (data === undefined || data === null) return false;
        if (Array.isArray(data)) {
            return data.length > 0;
        }
        if (typeof data === 'object') {
            return Object.keys(data).length > 0;
        }
        return true;
    }

    const groupsData = [
        { key: 'School', items: edu },
        { key: 'Pro', items: sortedPro },
        { key: 'Art Pass', items: sortedArt },
        { key: 'All-In-One', items: sortedAll },
    ];

    const groups = groupsData.filter(group => isNotEmpty(group.items));

    groups.sort((a, b) => {
        return compareLicenses(getGroupRepresentative(a.items), getGroupRepresentative(b.items));
    });

    return (
        <div className="main_back">
            <div className="main_part profile padding">
                <div className="profile_edit_box">
                    <div
                        className="title_box"
                        onClick={() => {
                            //navigate(-1);
                            navigate(routes?.Profile)
                        }}
                    >
                        <img src={require("../../assets/icon/back_arr.svg").default} alt="back" />
                        <p>{lang === 0 ? '라이선스 관리' : 'License Management'}</p>
                    </div>

                    <div className="licensing_back">
                        {noLicense ? (
                            <div className="licensing_box">
                                <div className="title_box">
                                    <p className="title">{lang === 0 ? '라이선스가 없습니다.' : 'No licenses available.'}</p>
                                </div>
                            </div>
                        ) : (
                            <>
                                {
                                    groups.map((group, index) => {
                                        if (group.key === 'School' || group.key === 'School') {
                                            return (
                                                <EduBox
                                                    eduData={[group.items]}
                                                    organization={organization}
                                                    chkReset={false}
                                                    selectedItems={[]}
                                                    setSelectedItems={() => { }}
                                                    modifyLicense={0}
                                                />
                                            );
                                        } else {
                                            return (
                                                <ProductBox
                                                    licenseGroup={group.items}
                                                    groupName={group.key}
                                                    organization={organization}
                                                    initialBoxView={true}
                                                    view={group.items[0].licenseGroup.licenseCategory}
                                                    payList={payList}
                                                    subscribelist={subscribelist}
                                                    payinfolists={payinfolists}
                                                />
                                            )
                                        }
                                    })
                                }
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}